import {
	PrimaryColor,
	BorderColor,
	GreySidely,
	LightGreySidely3,
	SidelyBlack,
	SurfaceColor
} from '../styles/global/css/Utils';
export const colourStyles = {
	valueContainer: styles => ({
		...styles,
		overflowX: 'scroll',
		overflowY: 'hidden',
		scrollbarWidth: 'none',
		display: '-webkit-inline-box',
		whiteSpace: 'nowrap',
		flexWrap: 'nowrap',
		flexDirection: 'row',
		position: 'relative'
	}),
	placeholder: defaultStyles => ({
		...defaultStyles,
		color: GreySidely
	}),
	control: styles => ({
		...styles,
		border: `1px solid color-mix(in oklab, ${SidelyBlack} 12.5%, transparent)`,
		borderRadius: '5px',
		'&:hover': {
			borderColor: PrimaryColor
		},
		minHeight: '38px',
		backgroundColor: SurfaceColor
	}),
	option: (styles, { data, isDisabled }) => {
		return {
			...styles,
			color: data.color,
			cursor: isDisabled ? 'not-allowed' : 'default',

			':active': {
				...styles[':active'],
				backgroundColor: SurfaceColor,
				color: data.color
			}
		};
	},
	multiValue: (styles, { data }) => {
		return {
			...styles,
			backgroundColor: SurfaceColor,
			borderRadius: '5px',
			border: '1px solid',
			borderStyle: data.type && data.type == 'operator' ? 'none' : 'solid',
			borderColor: data.color
		};
	},
	multiValueLabel: (styles, { data }) => {
		return {
			...styles,
			color: data.color,
			textDecoration:
				data.type && data.type == 'operator' ? 'underline' : 'none',
			fontFamily: 'Poppins'
		};
	},
	multiValueRemove: (styles, { data }) => {
		return data.type && data.type == 'operator'
			? {
				...styles,
				':hover': {
					color: SidelyBlack,
					padding: '2px 4px 4px 4px'
				}
			  }
			: {
				...styles,
				color: data.color,
				':hover': {
					backgroundColor: data.color,
					color: 'white',
					padding: '2px 4px 4px 4px'
				}
			  };
	}
};

export const styleOption = {
	placeholder: defaultStyles => ({
		...defaultStyles,
		color: GreySidely
	}),
	control: (styles, state) => ({
		...styles,
		borderColor: state.isFocused ? PrimaryColor : BorderColor,
		borderRadius: '0px 5px 5px 0px',
		borderLeft: 'transparent',
		boxShadow: state.isFocused ? 'none' : '',
		'&:hover': {
			borderColor: PrimaryColor
		},
		minHeight: '38px',
		backgroundColor: SurfaceColor
	}),
	option: (styles, { data, isDisabled }) => {
		return {
			...styles,
			color: data.color,
			cursor: isDisabled ? 'not-allowed' : 'default',

			':active': {
				...styles[':active'],
				backgroundColor: SurfaceColor,
				color: data.color
			}
		};
	},
	multiValue: (styles, { data }) => {
		return {
			...styles,
			backgroundColor: SurfaceColor,
			borderRadius: '5px',
			border: '1px solid',
			borderColor: data.color
		};
	},
	multiValueLabel: (styles, { data }) => ({
		...styles,
		color: data.color
	}),
	multiValueRemove: (styles, { data }) => ({
		...styles,
		color: data.color,
		':hover': {
			backgroundColor: 'transparant',
			color: data.color,
			padding: '2px 4px 4px 4px'
		}
	}),
	menuList: styles => ({
		...styles,
		'::-webkit-scrollbar': {
			width: '10px',
			borderRadius: '5px',
			background: `${LightGreySidely3} !important`
		},
		'::-webkit-scrollbar-track': {
			borderRadius: '5px'
		},
		'::-webkit-scrollbar-thumb': {
			background: PrimaryColor,
			borderRadius: '5px'
		}
	})
};
